import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PunchNotification } from '../../core/services/stomp-websocket.service';

@Component({
  selector: 'app-punch-notification-card',
  templateUrl: './punch-notification-card.component.html',
  styleUrls: ['./punch-notification-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PunchNotificationCardComponent {
  @Input() punch!: PunchNotification;
  @Input() title?: string;
  @Output() open = new EventEmitter<PunchNotification>();

  // TODO: Replace these with values from your design system / palette
  private readonly colorRedPunchA = '#d0021b'; // PA
  private readonly colorOrangePunchB = '#f5a623'; // PB
  private readonly colorPinkPrePunch = '#e91e63'; // PP (prepunch)
  private readonly colorAkerDarkBlue30 = '#003f5c';
  private readonly colorAccepted = '#2ecc71';

  get headerColor(): string {
    const p = this.punch;
    const isAccepted = !!p.acceptedBy || !!p.acceptedDate;
    const isCleared = !!p.clearedBy || !!p.clearedDate;

    // Accepted overrides everything
    if (isAccepted) {
      return this.colorAccepted;
    }

    // Cleared overrides category when not accepted
    if (isCleared) {
      return this.colorAkerDarkBlue30;
    }

    // Not cleared and not accepted: color by category value (PA/PB/PP)
    return this.categoryColor;
  }

  /** Color representing the punch category (used for header when open and for status dot). */
  get categoryColor(): string {
    switch (this.punch.category) {
      case 'PA':
        return this.colorRedPunchA;
      case 'PB':
        return this.colorOrangePunchB;
      case 'PP':
        return this.colorPinkPrePunch;
      default:
        return this.colorAkerDarkBlue30;
    }
  }

  onOpenClick(): void {
    this.open.emit(this.punch);
  }
}
